import PropTypes from 'prop-types'
import React from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility'

const Visibility = ({ className }) => <VisibilityIcon className={className} />

export default Visibility

Visibility.propTypes = {
  className: PropTypes.string
}
